import { defineEvent } from "@visioni/a3s-analytics";

/** The weekly schedule moved to another week. Camera scope comes from the route. */
export const ScheduleWeekChanged = defineEvent<{
  direction: "previous" | "next" | "today";
  via: "button" | "swipe";
}>("Schedule Week Changed");
